import Http from "../commons/utils/Http";
import { errorHandling } from "../commons/utils/error";

class usersService {

    async getAll(page) {
        try {
            let response = await Http.get(`/users/get-all?offset=${page}`, Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getId(id) {
        try {
            let response = await Http.get(`/users/get-by?field=id&value=${id}`, Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async search(body) {
        try {
            let response = await Http.post(`/users/search/userspartner`, body, Http.headers);
            return response
        } catch (e) {

        }
    }

    async searchUsers(search) {
        try {
            let response = await Http.get(`/users/search?search=${search}`,Http.headers)
            return response
        } catch (e) {

        }
    }

    async getPartnersByUserId(id) {
        try {
            let response = await Http.get(`/users/get-asscociations-by-user?id=${id}`, Http.headers);
            return response;
        } catch (e) {
            errorHandling(e)
        }
    }

    async getUsersByPartnerId(id_partner, page) {
        try {
            let response = await Http.get(`/users/get-users-access-management?id=${id_partner}&offset=${page}`, Http.headers);
            return response
        } catch (e) {

        }
    }

    async getCertificationsByUser(userId, lines = 20, order = 'id') {
        try {
            let response = await Http.get(
                `/users/get-certifications?id=${userId}&order=${order}&lines=${lines}`, Http.headers);
            return response
        } catch (e) {

        }
    }

    async searchCertificationsByUser(userId, search = '', lines = 20, order = 'id') {
        try {
            let response = await Http.get(
                `/users/search-certifications?id=${userId}&order=${order}&lines=${lines}&search=${search}`, Http.headers);
            return response
        } catch (e) {

        }
    }

    async insert(data) {
        try {
            let response = await Http.post(`/users`, data, Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async update(data) {
        try {
            let response = await Http.put(`/users`, data, Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async delete(id) {
        try {
            let response = await Http.delete(`/users/${id}`, Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async unlink(data) {
        try {
            let response = await Http.put(`/users/unlinkuserpartner`, data, Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async updatePhoto(data) {
        try {
            let response = await Http.post(`/users/upload`, data, Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async changePassword(data) {
        try {
            let response = await Http.put(`/users/change-password `, data, Http.headers);
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getPartnersApplicationAndRolesByUserId(id, search = '', pagination) {
        const offset = pagination.current;
        const lines = pagination.pageSize;
        try {
            let response = await Http.get(`/users/get-partners-applications-roles-by-user?id=${id}&search=${search}&offset=${offset}&lines=${lines}`, Http.headers);
            return response;
        } catch (e) {
            return null;
        }
    }
}

export default new usersService();
